/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";
import { BcsFlag } from "../unleash";

const FcsPermissionBagging = {
  validation_adjust_weight_proof_photo_enable: new FcsFlag.Flag(false),
  permission_bagging_dispute_summary_enable: new FcsFlag.Flag(false),
  bagging_label_a7_enabled: new FcsFlag.Flag(false),
  config_max_weight_dispute_bagging: new FcsFlag.NumberFlag(3),
  permission_bagging_rtc_v2_enable: new FcsFlag.Flag(false)
};

const BcsPermissionBagging = {
  config_dimension_divider: new BcsFlag.NumberFlag(4000),
  config_whitelist_client_max_weight_dispute: new BcsFlag.JSONFlag([])
};

export const FlagsPermissionBagging = {
  ...FcsPermissionBagging,
  ...BcsPermissionBagging
};

export function initFlagsPermissionBagging() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureBagging", FcsPermissionBagging);
  BcsFlag.register("featureBagging", BcsPermissionBagging);
}
